import {IMAGE_URL, SOCKET} from "../../URL";
import {Link} from "react-router-dom";
import {BoardsCreate} from "./BoardsCreate";
import {useDispatch, useSelector} from "react-redux";
import {HandleBoardAPI} from "../../store/api/get/Board/Board";
import {useEffect, useState} from "react";
import {SET_BOARD} from "../../store/constants";

export const BoardsUIX = ({
                              boards,
                              setActiveBoard,
                              is_create
                          }) => {
    const dispatch = useDispatch();
    const reduxBoards = useSelector(state => state.boards.boards);
    const [updatedBoards, setUpdatedBoards] = useState([]);
    console.log(boards);
    useEffect(() => {
        setUpdatedBoards(reduxBoards);
    }, [reduxBoards]);

    const handleRestore = async (id) => {
        const newBoards = updatedBoards.map(board =>
            board.id === id
                ? {...board, is_archive: false}
                : board
        );

        setUpdatedBoards(newBoards);
        dispatch({type: SET_BOARD, payload: newBoards});

        await dispatch(HandleBoardAPI(id));
    };
    useEffect(() => {
        const handleBoard = (data) => {
            setUpdatedBoards((prev) => {
                const newBoards = prev.map((board) =>
                    board.id === data.id
                        ? {
                            ...board,
                            is_archive: data.is_archive
                        }
                        : board
                );

                dispatch({
                    type: SET_BOARD,
                    payload: newBoards
                });

                return newBoards;
            });
        };

        SOCKET.on("handle_board", handleBoard);

        return () => {
            SOCKET.off("handle_board", handleBoard);
        };
    }, [dispatch]);
    console.log(boards);
    return (
        <div className="workspace__boards">
            {
                boards?.map((el) => {
                    const isUploadedImage = el.path?.startsWith("uploads");
                    const imageURL = isUploadedImage
                        ? IMAGE_URL + "/media/" + el.path
                        : null;
                    const background = el.path || "#253545";

                    return (
                        <div className="board__item" key={el.id}>

                            <Link
                                to={!el.is_archive ? `/board/${el.id}` : "#"}
                                onClick={() => setActiveBoard(el)}
                                className="board__card"
                            >
                                {
                                    isUploadedImage ? (
                                        <img src={imageURL} alt={el.name} />
                                    ) : (
                                        <div
                                            className="board__item-background"
                                            style={{ background }}
                                        />
                                    )
                                }

                                <h3>{el.name}</h3>
                            </Link>

                            {el.is_archive && (
                                <button
                                    className="board__restoreBtn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleRestore(el.id);
                                    }}
                                >
                                    Restore
                                </button>
                            )}
                        </div>
                    );
                })
            }

            {
                is_create && (
                    <BoardsCreate
                        is_header={false}
                    />
                )
            }
        </div>
    );
};
